export const MODEL_OPTIONS = [
  { id: "350M", label: "LFM2-350M", size: "350M parameters (312 MB)" },
  { id: "700M", label: "LFM2-700M", size: "700M parameters (579 MB)" },
  { id: "1.2B", label: "LFM2-1.2B", size: "1.2B parameters (868 MB)" },
];
